import React from 'react';
import VendexAction from '../../../models/VendexAction';
import { VendexImageMeta } from '../../../models/VendexElement';
import useEventListner from '../../useEventListner';
import { PageContext } from '../..';

const defaultImage =
  'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAeAAAAFAAQMAAABeBj04AAAABlBMVEXMzMyWlpYU2uzLAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAKklEQVR4nO3BAQ0AAADCoPdPbQ43oAAAAAAAAAAAAAAAAAAAAAAAAIAXA0xAAAHTKSJxAAAAAElFTkSuQmCC';

type Props = {
  id: string;
  actions?: VendexAction[];
  data: VendexImageMeta;
};

const VendexImage: React.FC<Props> = ({ id, data, actions }) => {
  const [value, setValue] = React.useState<string>(defaultImage);
  const ref = React.useRef<HTMLImageElement>(null);
  const { source, type = 'STATIC' } = data;
  const {store} = React.useContext(PageContext);

  useEventListner(ref, actions);

  React.useEffect(() => {
    if (type === 'DYNAMIC' && source.length > 0) {
      setValue(store.data[source] ?? defaultImage);
    } else {
      setValue(source);
    }
  }, [store.data]);

  if (!source || source.length == 0) return null;

  return <img src={value} id={id} ref={ref} data-vendex />;
};
export default VendexImage;
